module.exports = ".ThSort_icon{margin-left:0.5rem}\n"